

export interface IUndoRedoElement {
    /**
     * A human-readable name for the action.
     */
    readonly label: string;

    /**
     * A code describing the action (for localization or categorization purposes).
     */
    readonly code?: string;


    undo: () => void
    perform: () => void
}

export class CompundUndoRedo implements IUndoRedoElement {
    private readonly actions: IUndoRedoElement[] = [];

    constructor(init: {
        label: string,
        actions: IUndoRedoElement[]
    }) {
        this._label = init.label;
        this.actions = [...init.actions];
    }
    private readonly _label: string;
    get label(): string {
        return this._label;
    }

    undo() {
        for (let i = this.actions.length - 1; i >= 0; i--) {
            this.actions[i].undo();
        }
    }
    perform() {
        for (const action of this.actions) {
            action.perform();
        }
    }
}

export class BaseAction implements IUndoRedoElement {

    private readonly _label: string;
    readonly undo: () => void;
    readonly perform: () => void;

    constructor(init: {
        label: string,
        undo: () => void,
        perform: () => void
    }) {
        this._label = init.label;
        this.undo = init.undo;
        this.perform = init.perform;
    }

    get label(): string {
        return this._label;
    }
}
